@if (sortedHotels().length > 0) {
	@for (hotel of sortedHotels(); track hotel.slug) {
		<vp-persuade-card
			[cardUrl]="hotel.cardUrl"
			[content]="hotel.content"
			[ctaText]="
				(business() ? 'global.goto-hotel-cta' : 'global.book-directly')
					| translate
			"
			[ctaUrl]="hotel.toUrl"
			[images]="hotel.images"
			[overline]="hotel.country"
			[price]="
				showPrices() && hotel.availability.isBookable && hotel.price
			"
			[pricingToolTip]="{
				occupancy: pricingTooltipOccupancy,
			}"
			[showReadMore]="!business()"
			[socialProof]="
				hotel.rating && {
					score: hotel.rating.score,
					numberOfRatings: hotel.rating.numberOfRatings,
				}
			"
			[title]="hotel.name"
		/>
	}
} @else {
	<vp-alert
		[content]="
			'storyblok.pages.filterable-list.no-results.description' | translate
		"
		[emphasized]="true"
		[title]="'storyblok.pages.filterable-list.no-results.title' | translate"
		type="dialog--warning"
	/>
}
